import { render, staticRenderFns } from "./SectionStart.vue?vue&type=template&id=7385e04f&scoped=true&"
import script from "./SectionStart.vue?vue&type=script&lang=js&"
export * from "./SectionStart.vue?vue&type=script&lang=js&"
import style0 from "./SectionStart.vue?vue&type=style&index=0&id=7385e04f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385e04f",
  null
  
)

export default component.exports